module.exports = __webpack_public_path__ + "static/media/ic_upload.3f7e59cc.svg";